<template>
  <div class="form-group">
    <b-row v-for="(variant, index) in localData" :key="index" class="variant-block">
      <b-col>
        <b-row class="mb-1">
          <b-col>
            <b-form-checkbox
              :id="`checkbox-${variant.id}`"
              :name="`checkbox-${variant.id}`"
              v-model="variant.isCustom"
              @change="checked(variant)"
            >
              Custom Variant
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="variant-fields-row">
          <b-col
            cols="12"
            sm="6"
            lg="4"
            xl="3"
            v-for="(variance, i) in varianceData"
            :key="i"
            class="mb-2"
          >
            <label>{{ variance.attrRef.attributeName }}</label>
            <b-form-input
              v-if="localData[index].isCustom == true"
              class="margin-b"
              type="text"
              @change="
                changeVariantAttribute(
                  variant,
                  variance.attrRef.attributeName,
                  variantAttribute
                )
              "
              min="0"
              v-model="variant.attributes[variance.attrRef.attributeName]"
              :id="'Price'"
              :placeholder="`Enter  ${variance.attrRef.attributeName}`"
            ></b-form-input>
            <v-select
              v-else
              label=""
              class="form-group text-muted"
              :clearable="false"
              :options="variance.data"
              :value="variant.attributes[variance.attrRef.attributeName]"
              @input="
                onchangeSelect(variant, variance.attrRef.attributeName, $event)
              "
              :placeholder="`Select ${variance.attrRef.attributeName}`"
            ></v-select>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3" class="mb-2">
            <label>Price:</label>
            <b-form-input
              type="text"
              @input="onchange"
              min="0"
              v-model="variant.Price"
              :id="'Price'"
              placeholder="Enter Price"
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3" class="mb-2" v-if="!isService">
            <label>SKU Number:</label>
            <b-form-input
              type="text"
              @input="onchange"
              min="0"
              v-model="variant.skuNo"
              :id="'Price'"
              placeholder="Enter SKU Number"
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3" class="mb-2" v-if="!isService">
            <label>Inventory:</label>
            <b-form-input
              type="text"
              @input="onchange"
              min="0"
              v-model="variant.Inventory"
              :id="'Price'"
              placeholder="Enter Inventory"
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3" class="mb-2" v-if="!isService">
            <label>Stock Count:</label>
            <b-form-input
              type="text"
              @input="onchange"
              min="0"
              v-model="variant.StockCount"
              :id="'Price'"
              placeholder="Enter Stock Count"
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3" class="mb-2" v-if="!isService">
            <label>Discount:</label>
            <b-form-input
              type="number"
              @input="
                onchange(variant, variant.Discount, variant.DiscountPercentage)
              "
              min="0"
              v-model="variant.Discount"
              :disabled="variant.DiscountPercentage > 0"
              :id="'Discount'"
              placeholder="Enter Discount"
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3" class="mb-2" v-if="!isService">
            <label>Discount(%):</label>
            <b-form-input
              type="number"
              @input="
                onchange(variant, variant.Discount, variant.DiscountPercentage)
              "
              min="0"
              v-model="variant.DiscountPercentage"
              :disabled="variant.Discount > 0"
              :id="'Discount(%)'"
              placeholder="Enter Discount(%)"
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3" class="mb-2" v-if="!isService">
            <label>Deal Price:</label>
            <b-form-input
              type="number"
              @input="onchange"
              min="0"
              v-model="variant.DealPrice"
              :id="'DealPrice'"
              placeholder="Enter Deal Price"
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3" class="mb-2" v-if="!isService">
            <label>Slot Limit:</label>
            <b-form-input
              type="number"
              @input="onchange"
              min="0"
              v-model="variant.slotLimit"
              :id="'slotLimit'"
              placeholder="Enter Slot Limit"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="variant-actions-row">
          <b-col cols="12" sm="6" md="4" lg="3" class="mb-2 switch-col">
            <v-switch
              color="#449e48"
              v-model="variant.isDefault"
              label="Default"
              @change="setDefault(variant, variant.isDefault)"
            ></v-switch>
          </b-col>
          <b-col cols="12" sm="6" md="8" lg="9" class="mb-2">
            <b-button
              v-if="index === localData.length - 1"
              class="action-btn"
              btn-special="primary"
              size="sm"
              @click="addVariant()"
            >
              <i class="fa fa-plus-circle"></i>
            </b-button>

            <b-button
              class="action-btn mr-2"
              btn-special="danger"
              size="sm"
              @click="removeVariant(index)"
              variant="danger"
            >
              <i class="fa fa-minus-circle"></i>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "variance",
  components: {
    vSelect,
  },
  data() {
    return {
      localData: [],
      isCustom: "",
      variantAttribute: "",
    };
  },
  props: {
    varianceData: {
      type: Array,
      default() {
        return [];
      },
    },
    isService: {
      type: Boolean,
      default: false,
    },
    variableDetails: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    checked(val) {
      //This code is not relevent but it fixes the UI not updating issue
      this.onchange(val, val.Discount + 1, val.DiscountPercentage);
      this.onchange(val, val.Discount, val.DiscountPercentage);
    },
    onchangeSelect(data, event, value) {
      data.attributes[event] = value;
      this.localData.map((obj) => {
        if (obj.id === data.id) {
          obj = data;
        }
      });
      this.$emit("change", this.localData);
    },
    onchange(data, discount, discountPercent) {
      if (data.Price > 0) {
        if (discount > 0) {
          this.localData.map((obj) => {
            if (obj.id === data.id) {
              obj.DealPrice = obj.Price - discount;
            }
          });
        }
        if (discountPercent > 0) {
          this.localData.map((obj) => {
            if (obj.id === data.id) {
              obj.DealPrice = obj.Price - (obj.Price * discountPercent) / 100;
            }
          });
        }
      }

      this.$emit("change", this.localData);
    },
    changeVariantAttribute(data, attr, val) {
      this.localData.map((obj) => {
        if (obj.id === data.id) {
          obj = data;
        }
      });
      this.$emit("change", this.localData);
    },
    setDefault(val, isDefault) {
      this.localData.forEach((el) => {
        if (el.id !== val.id && val.isDefault && el.isDefault) {
          el.isDefault = false;
        }
      });
      let availableDefault = this.localData.find((el) => el.isDefault === true);
      this.$emit("changeDefault", availableDefault);
    },
    addVariant() {
      let dataobj = {
        attributes: {},
        Price: 0,
        isDefault: false,
        isRemovable: false,
        id: Date.now(),
      };

      if (!this.isService) {
        this.varianceData.map((obj) => {
          if (obj) {
            dataobj.attributes[obj.attrRef.attributeName] = "";
          }
        });
      } else {
        dataobj.slotLimit = 0;
      }

      this.localData.push(dataobj);
    },

    removeVariant(index) {
      if (this.localData.length > 1) {
        this.localData.splice(index, 1);
      }
    },
  },
  mounted() {
    if (this.variableDetails.length > 0) {
      this.localData = this.variableDetails.map((el) => {
        if (el.isCustom != false) el.isCustom = true;
        el.id = el._id;
        return el;
      });
    } else {
      if (!this.isService) {
        let dataobj = {
          isCustom: false,
          attributes: {},
          Price: 0,
          skuNo: 0,
          StockCount: 0,
          Inventory: 0,
          DealPrice: 0,
          Discount: 0,
          DiscountPercentage: 0,
          isDefault: false,
          isRemovable: false,
          id: Date.now(),
        };
        this.varianceData.map((obj) => {
          if (obj) {
            dataobj.attributes[obj.attrRef.attributeName] = "";
          }
        });
        if (dataobj.Discount > 0) {
          delete dataobj.DiscountPercentage;
        }
        if (dataobj.DiscountPercentage > 0) {
          delete dataobj.Discount;
        }
        this.localData.push(dataobj);
      } else {
        let dataobj = {
          attributes: {},
          slotLimit: 0,
          isDefault: true,
          isRemovable: false,
          id: Date.now(),
        };
        this.varianceData.map((obj) => {
          if (obj) {
            dataobj.attributes[obj.attrRef.attributeName] = "";
          }
        });
        this.localData.push(dataobj);
      }
    }
  },
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.margin-b {
  margin-bottom: 14px;
}
.form-group {
  cursor: pointer !important;
}
.variant-block {
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 12px;
  padding-bottom: 10px;
}
.variant-fields-row label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
}
.variant-actions-row {
  align-items: flex-end;
}
.switch-col {
  padding-top: 4px;
}
.action-btn {
  float: right;
  min-width: 36px;
}
</style>
